import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';

import SettingsItemTitle from './ItemTitle';

const SettingsItemText = ({
  settingKey,
  setting,
  disabled,
  handleChange,
}) => (
  <Label for={`setting-${settingKey}`} className={classnames({ disabled })} disabled={disabled}>
    <SettingsItemTitle setting={setting} />
    <div className="input-inner">
      <Input
        type="text"
        name={`setting-${settingKey}`}
        id={`setting-${settingKey}`}
        value={setting.value}
        disabled={disabled || settingKey === 'public_file_urls_domain'}
        onChange={handleChange}
      />
    </div>
  </Label>
);

SettingsItemText.propTypes = {
  settingKey: PropTypes.string.isRequired,
  setting: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

SettingsItemText.defaultProps = {
  disabled: false,
};

export default SettingsItemText;
